import { createContext, useContext, useState, ReactNode } from "react";
import { UserContext } from "./UserContext";
import api from "../service/api";
import { toast } from "react-toastify";

interface ITechs {
  id: string;
  title: string;
  status: string;
}

interface ITechAdd {
  title: string;
  status: string;
}

interface TechsProps {
  children: ReactNode;
}

interface TechsData {
  newTech: (data: ITechAdd) => void;
  showAddModal: boolean;
  setShowAddModal: Function;
  removeTech: (techToRemove: ITechs) => void;
}

export const TechsContexts = createContext<TechsData>({} as TechsData);

export const TechsProvider = ({ children }: TechsProps) => {
  const { setLoading, userTechsList, setUserTechsList } =
    useContext(UserContext);

  const [showAddModal, setShowAddModal] = useState<boolean>(false);

  const newTech = async (data: ITechAdd) => {
    const token = localStorage.getItem("@token");
    setLoading(true);

    if (token) {
      try {
        api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

        const response = await api.post("/users/techs", data);

        setUserTechsList([...userTechsList, response.data]);
        toast.success("Tecnologia adicionada com sucesso!", {
          theme: "dark",
        });
      } catch (error) {
        console.log(error);
        toast.error("Ops, algo deu errado!", {
          theme: "dark",
        });
      }
    }

    setLoading(false);
    setShowAddModal(false);
  };

  const removeTech = (techToRemove: ITechs) => {
    const token = localStorage.getItem("@token");
    const updatedTechs = userTechsList.filter(
      (tech: ITechs) => tech.id !== techToRemove.id
    );

    try {
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`;

      api.delete(`/users/techs/${techToRemove.id}`);
      setUserTechsList(updatedTechs);
      toast.success("Tecnologia excluída com sucesso!", {
        theme: "dark",
      });
    } catch (error) {
      toast.error("Ops! Algo deu errado!", {
        theme: "dark",
      });
      console.log(error);
    }
  };

  return (
    <TechsContexts.Provider
      value={{
        newTech,
        showAddModal,
        setShowAddModal,
        removeTech,
      }}
    >
      {children}
    </TechsContexts.Provider>
  );
};
